import { useEffect, useState } from 'react';
import { FormConfig, getFormConfig } from '../services/api';
import { DEFAULT_FORM_CONFIG } from '../lib/formRules';

// Prices and rules from the backoffice settings; falls back to the defaults when unreachable
export const useFormConfig = () => {
  const [config, setConfig] = useState<FormConfig>(DEFAULT_FORM_CONFIG);

  useEffect(() => {
    let cancelled = false;
    getFormConfig()
      .then((data) => {
        if (!cancelled) setConfig({ ...DEFAULT_FORM_CONFIG, ...data });
      })
      .catch(() => {
        // Keep the defaults
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return config;
};
